'use client'

import MainLayout from '@/components/layouts/MainLayout'
import ApolloProviderWrapper from './ApolloProviderWrapper'

export default function RootLayoutClient({ children }: { children: React.ReactNode }) {
  return (
    <ApolloProviderWrapper>
      <MainLayout>{children}</MainLayout>
    </ApolloProviderWrapper>
  )
}
